<script setup lang="ts">
import useFetch from './useFetch'
import type { VoucherType } from '#build/stores/payment/types'

const props = withDefaults(
  defineProps<{
    selectedVoucher?: VoucherType
  }>(),
  {
    selectedVoucher: () => null
  }
)

const { selectedVoucher } = toRefs(props)

const emits = defineEmits(['onBack'])
const {
  getQueryStringFromObject,
  courseDetail,
  paymentStore,
  vouchersPublic,
  expandKey,
  activeVoucher,
  resetVoucher,
  voucherCode,
  getVoucherByCode
} = useFetch({ emits, selectedVoucher })

onMounted(() => {
  paymentStore.getVouchersPublic({
    params: getQueryStringFromObject({
      courseSerial: courseDetail.value?.data?.serial
    })
  })
})
</script>

<template>
  <div id="buy-course-voucher" class="buy-course-voucher">
    <div class="voucher-head">
      <div class="head-title">
        <div class="back" @click="emits('onBack', activeVoucher)">
          <ArrowLeftOutlined />
        </div>
        <div class="ml-3">Pilih Voucher</div>
      </div>
      <a-button type="text" class="vourcher-reset" @click="resetVoucher">
        Reset
      </a-button>
    </div>

    <div class="voucher-form">
      <a-input
        v-model:value="voucherCode"
        placeholder="Masukkan kode"
        size="large"
      />
      <a-button
        type="primary"
        size="large"
        :disabled="isEmpty(voucherCode)"
        @click="getVoucherByCode"
      >
        Gunakan
      </a-button>
    </div>

    <div class="voucher-list">
      <ul v-if="vouchersPublic?.isLoading" class="voucher-content">
        <li v-for="i in 5" :key="i">
          <LazyModulesKursusDetailAtomsVoucherCardLoading />
        </li>
      </ul>

      <template
        v-else-if="!vouchersPublic?.isLoading && !isEmpty(vouchersPublic?.data)"
      >
        <ul class="voucher-content">
          <li
            v-for="voucherAvailabel in vouchersPublic?.data?.availableVouchers"
            :key="voucherAvailabel?.serial"
          >
            <LazyModulesKursusDetailAtomsVoucherCard
              :is-active="voucherAvailabel?.serial === activeVoucher?.serial"
              :voucher="voucherAvailabel"
              @on-click="activeVoucher = voucherAvailabel"
            />
          </li>
        </ul>
        <a-collapse
          v-model:active-key="expandKey"
          ghost
          expand-icon-position="right"
          class="voucher-content-unsued"
        >
          <template #expandIcon="{ isActive }">
            <LazyAtomsArrowDown :rotate="isActive ? -180 : 0" />
          </template>
          <a-collapse-panel key="1" header="Voucher yang belum bisa dipakai">
            <ul class="voucher-content">
              <li
                v-for="voucherUnavailabel in vouchersPublic?.data
                  ?.unAvailableVouchers"
                :key="voucherUnavailabel?.serial"
              >
                <LazyModulesKursusDetailAtomsVoucherCard
                  :voucher="voucherUnavailabel"
                  un-used
                />
              </li>
            </ul>
          </a-collapse-panel>
        </a-collapse>
      </template>
    </div>
  </div>
</template>

<style lang="scss">
@use './styles.scss';
</style>
